import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Adiantamento } from '../../../../types/Adiantamento.type';

@Injectable({
  providedIn: 'root'
})
export class AdiantamentoService {

  constructor(private configService: ConfigService, private httpClient: HttpClient) { }

  getPagamentos(instancias: string, dataInicial: string | null, dataFinal: string | null) {
    return this.httpClient.get<Adiantamento[]>(`${this.configService.getApiUrlRoot()}/pagamentos/?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  buscaPagamentos(instancias: string, dataInicial: string | null, dataFinal: string | null) {
    return this.httpClient.get<Adiantamento[]>(`${this.configService.getApiUrlRoot()}/pagamentos/pims/buscar?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  enviaPagamentosErp(corpo: any) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/pagamentos/integracao`, corpo)
  }

  exportarPagamentos(corpo: any) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/pagamentos/relatorios/exportar`, corpo, { responseType: 'blob' })
  }

  cancelarPagamento(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/pagamentos/cancelar-folha`, corpo)
  }

  estornatPagamento(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/pagamento/estornar-folha`, corpo)
  }
}
